module.exports = __webpack_public_path__ + "img/web.f4e4edd6.svg";